import makeApi from 'libs/core/configureAxios'

const api = makeApi(`${process.env.REACT_APP_API_BASE_URL}`)

const getUsers = payload => api.get('/platform/users', payload)

const createUser = payload => api.post(`/platform/users`, payload.data, { params: payload.params })

const editUser = payload => api.put(`/platform/users`, payload.data, { params: payload.params })

const editUserGroup = payload =>
  api.put(`/platform/users/${payload.userId}/user-groups`, payload.data, { params: payload.params })

const deleteUser = payload =>
  api.delete(`/platform/users/${payload.userId}`, { params: payload.params })

export default {
  getUsers,
  createUser,
  editUser,
  editUserGroup,
  deleteUser,
}
